// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"94ff5187","160":"2cf7612e","208":"5ccdc276","293":"f2dbe920","516":"a12c9ee9","519":"54f097b2","917":"02f90124","946":"47a6c268"}[chunkId] + ".chunk.js";
};